import styled from 'styled-components';
import tw from 'twin.macro';
import { APP_BUILD_TIME, APP_VERSION } from '../../config/app-version';

type AppVersionLabelProps = {
  variant?: 'page' | 'modal';
};

const PageLabel = styled.p`
  ${tw`w-full max-w-md min-w-0 mx-auto px-4 mt-6 pb-8 text-center text-xs text-gray-400 box-border`}
`;

const ModalLabel = styled.p`
  ${tw`mt-6 pt-4 border-t border-gray-100 text-center text-xs text-gray-400`}
`;

function versionLabelText(): string {
  const base = `v${APP_VERSION}`;
  if (!APP_BUILD_TIME) {
    return base;
  }
  return `${base} · ${new Date(APP_BUILD_TIME).toLocaleDateString()}`;
}

export function AppVersionLabel({ variant = 'page' }: AppVersionLabelProps) {
  const Label = variant === 'modal' ? ModalLabel : PageLabel;
  return <Label>{versionLabelText()}</Label>;
}
